/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertWorkUnitsSettingsRequestBody,
  UpsertWorkUnitsSettingsRequestBody$Outbound,
  UpsertWorkUnitsSettingsRequestBody$outboundSchema,
} from "../components/upsertworkunitssettingsrequestbody.js";

export type UpsertChatAnalysisSettingsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertChatAnalysisSettingsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertWorkUnitsSettingsRequestBody: UpsertWorkUnitsSettingsRequestBody;
};

/** @internal */
export type UpsertChatAnalysisSettingsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertChatAnalysisSettingsSecurity$outboundSchema: z.ZodMiniType<
  UpsertChatAnalysisSettingsSecurity$Outbound,
  UpsertChatAnalysisSettingsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function upsertChatAnalysisSettingsSecurityToJSON(
  upsertChatAnalysisSettingsSecurity: UpsertChatAnalysisSettingsSecurity,
): string {
  return JSON.stringify(
    UpsertChatAnalysisSettingsSecurity$outboundSchema.parse(
      upsertChatAnalysisSettingsSecurity,
    ),
  );
}

/** @internal */
export type UpsertChatAnalysisSettingsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpsertWorkUnitsSettingsRequestBody:
    UpsertWorkUnitsSettingsRequestBody$Outbound;
};

/** @internal */
export const UpsertChatAnalysisSettingsRequest$outboundSchema: z.ZodMiniType<
  UpsertChatAnalysisSettingsRequest$Outbound,
  UpsertChatAnalysisSettingsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    upsertWorkUnitsSettingsRequestBody:
      UpsertWorkUnitsSettingsRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      upsertWorkUnitsSettingsRequestBody: "UpsertWorkUnitsSettingsRequestBody",
    });
  }),
);

export function upsertChatAnalysisSettingsRequestToJSON(
  upsertChatAnalysisSettingsRequest: UpsertChatAnalysisSettingsRequest,
): string {
  return JSON.stringify(
    UpsertChatAnalysisSettingsRequest$outboundSchema.parse(
      upsertChatAnalysisSettingsRequest,
    ),
  );
}
